import * as THREE from 'three';
import {createLight, createBackground} from './helper';
import settings from '../config/Settings';
import NearStars from './objects/NearStars';
import Sun from './objects/Sun';
import Planets from './objects/Planets';
import Beam from './objects/Beam';

class Universe {
  constructor() {
    this.planets = new Planets(settings);
    this.sun = new Sun();
    this.nearStars = new NearStars();
    this.beam = new Beam(settings);
    this.visibleLabels = true;

    this.three = {
      scene: this.createScene()
    }
  }

  // return THREE.Scene
  createScene() {
    const light = createLight();
    const background = createBackground();

    const scene = new THREE.Scene();
    scene.add(light);
    scene.add(background);
    scene.add(this.getSun().three?.sun);
    this.getPlanets().three.planets.map(planet => scene.add(planet));
    scene.add(this.getBeam().three?.beamGroup);
    this.getNearstars().three.nearStars.map(nearStar => scene.add(nearStar));
    return scene;
  }
  
  getSun() {
    return this.sun;
  }

  getPlanets() {
    return this.planets;
  }

  getNearstars() {
    return this.nearStars;
  }

  getBeam() {
    return this.beam;
  }

  getLabels() {
    // Cache all labels in class property this.labels
    if (!this.labels) {
      let labels = [this.sun.getLabel()];
      labels = labels.concat(this.nearStars.getLabels());
      labels = labels.concat(this.planets.three.labels);
      this.labels = labels;
    }
    return this.labels;
  }

  showLabels() {
    this.getLabels().map(label => (label.visible = true));
    this.visibleLabels = true;
  }

  hideLabels() {
    this.getLabels().map(label => (label.visible = false));
    this.visibleLabels = false;
  }

  showOrbits() {
    this.planets.three.planets.map(planet => (planet.orbit.visible = true));
  }

  hideOrbits() {
    this.planets.three.planets.map(planet => (planet.orbit.visible = false));
  }

  updateLabelScales(cameraPosition) {
    this.getLabels().map(label => {
      const distanceToLabel = cameraPosition.distanceTo(label.position)

      if (label.maxDistance && distanceToLabel > label.maxDistance) {
        label.visible = false;
        return null;
      } else {
        label.visible = true
      }

      // calculate label scale
      const logDistanceToLabel = Math.log(distanceToLabel)
      const scale = (5 * label.canvasWidthCoefficient * label.scaleCoefficient) * distanceToLabel * (1 / Math.pow(logDistanceToLabel, label.scaleLogCoefficient))

      label.scale.x = scale
      label.scale.y = scale
      label.scale.z = scale

      return null;
    })
  }
}

export default Universe